export const getWrapperStyles = customStyles => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-end',
  flexWrap: 'nowrap',
  gap: '12px',
  paddingBottom: '18px',

  ...customStyles,
});

export const buttonStyles = {
  padding: 0,

  '&:hover': {
    opacity: '0.6',
    backgroundColor: 'transparent',
  },
};
